import { Component, OnInit } from "@angular/core";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { constants } from "src/app/shared/common/contants";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { DeviationService } from "src/app/shared/services/deviation.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Messages } from "src/app/shared/Validations/messages";
import { DetailRowRendererComponent } from "../detail-row-renderer/detail-row-renderer.component";
import { DeviationComponent } from "../deviation.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "app-deviation-management",
    templateUrl: "./deviation-management.component.html",
    styleUrls: ["./deviation-management.component.scss"],
    standalone: false
})
export class DeviationManagementComponent implements OnInit {
  backgroundColorScreen = "";
  backgroundColorButton = "";
  gridAPI: any;
  columnDefs: any;
  rowSelection: any;
  defaultColDef: any;
  paginationPageSize: any;
  paginationNumberFormatter: any;
  rowClassRules: any;
  lastPage: any;
  currentPage: any;
  nextPage: any;
  nextPagePlusOne: any;
  totalPages: any;
  components: any;
  gridColumnAPI: any;
  pageSize: any;
  value: any;
  gridOptions: any;
  expandedRowId: any;
  baseRowData: any[] = [];
  expandedParentId: string | null = null;
  deviationFor: string = "Global Deviation";
  urlDeviationId: string | null = null;
  showClearFilterCheckbox = false;
  isFilterApplied = false;
  
  // Pagination management
  private originalPageSize = 5;
  private isDetailExpanded = false;
isSidenavOpen=true
selectedProductDetails:any=null;
  constructor(
    private constants: constants,
    private localStorageSettings: LocalStorageSettingsService,
    private jsignalsService: JsignalService,
    private deviationService: DeviationService,
    private snackbar: MatSnackBar,
    private msg: Messages,
    private router: Router,
    private spinner: NgxUiLoaderService,
    public dialog: MatDialog,
    private route: ActivatedRoute
  ) {
    this.components = {
      detailRowRenderer: DetailRowRendererComponent,
      jsignalButton: JSIGNALBUTTON,
    };
  }

  ngOnInit(): void {
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.initializeGrid();

    this.route.params.subscribe((params) => {
      if (params["deviationId"]) {
        this.urlDeviationId = params["deviationId"];
        this.showClearFilterCheckbox = true;
      }
    });
  }

  // ========== GRID INITIALIZATION ==========
  private initializeGrid(): void {
    this.gridOptions = this.createGridOptions();
    this.columnDefs = this.createColumnDefs();
    this.setupGridConfiguration();
  }

  private createGridOptions(): any {
    return {
      suppressRowClickSelection: true,
      isFullWidthRow: (params) => params.rowNode.data?.__isDetail === true,
      fullWidthCellRenderer: "detailRowRenderer",
      getRowHeight: (params) => params.data?.__isDetail ? 450 : 35,
      onFirstDataRendered: (params) => params.api.resetRowHeights(),
      getRowId: (params) => params.data.id,
      context: { componentParent: this },
      doesExternalFilterPass: (node) => {
        if (node.data?.__isDetail) return true;
        return true;
      },
    };
  }

/**
 * @note
 * If a new column is added here, the same field must also be added in
 * `copyParentDataForFiltering()`.
 *
 * This is required to ensure filtering continues to work correctly
 * when a detail row is created.
 */

  private createColumnDefs(): any[] {
    return [
      {
        headerName: "Action",
        filter: false,
        cellRenderer: "jsignalButton",
        colId: "Action",
        cellClass: "action-cell",
        cellRendererParams: (params: any) => ({
          edit: this.EditIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        }),
        pinned: "left",
        lockPinned: true,
        width: 200,
      },
      {
        headerName: "Deviation Id",
        field: "deviationId",
         ...this.jsignalsService.autoTooltip("Deviation Id"),
        filter: "agTextColumnFilter",
        width: 180,
      },
      {
        headerName: "State",
        ...this.jsignalsService.autoTooltip("State"),
        field: "state",
        filter: "agTextColumnFilter",
        width: 180,
      },
      {
        headerName: "Deviation Created For",
        ...this.jsignalsService.autoTooltip("Deviation Created For "),
        field: "deviationFor",
        filter: "agTextColumnFilter",
        width: 200,
      },
      {
        headerName: "Product Name",
        ...this.jsignalsService.autoTooltip("Product Name"),
        field: "productName",
        filter: "agTextColumnFilter",
        width: 180,
      },
      {
        headerName: "Closure Date",
        ...this.jsignalsService.autoTooltip("Closure Date"),
        field: "dateClosure",
        filter: "agTextColumnFilter",
        width: 180,
      },
      {
        headerName: "Status",
        ...this.jsignalsService.autoTooltip("Status"),
        field: "status",
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
      headerName: "External Sync Status",
      field: "vaultSyncStatus",
      filter: "agTextColumnFilter",
      headerTooltip: "External Sync Status",
      tooltipValueGetter: (params) => "External Sync Status  : " + params.value,
      hide: false,
      width: 180,
    },
    {  
      headerName: "External Reference ID",
      field: "vaultReference",
      filter: "agTextColumnFilter",
      headerTooltip: "External Reference ID",
      tooltipValueGetter: (params) => "External Reference ID : " + params.value,
      hide: false,
      width: 180,
    },
      {
        headerName: "Created By",
        ...this.jsignalsService.autoTooltip("Created By"),
        field: "createdBy",
        filter: "agTextColumnFilter",
        width: 180,
      },
      {
        headerName: "Created At",
        ...this.jsignalsService.autoTooltip("Created At"),
        field: "createdDate",
        filter: "agTextColumnFilter",
        width: 180,
      },
      {
        headerName: "Last Modified By",
        ...this.jsignalsService.autoTooltip("Last Modified By"),
        field: "lastModifiedBy",
        filter: "agTextColumnFilter",
        width: 200,
      },
      {
        headerName: "Last Modified At",
        ...this.jsignalsService.autoTooltip("Last Modified At"),
        field: "lastModifiedDate",
        filter: "agTextColumnFilter",
        width: 200,
      },
    ];
  }

  private setupGridConfiguration(): void {
    this.rowClassRules = {
      rowBackgroundColor: (params) => {
        const status = params.node.data.status;
        return status === "No" || status === null;
      },
    };

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true,
      cellClassRules: {
        "ag-hidden-cell": (params: any) => params.data?.__isDetail === true,
      },
    };

    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.originalPageSize;
    this.paginationNumberFormatter = (params) => params.value.toLocaleString();
  }

  // ========== GRID EVENTS ==========
  onGridReady(params): void {
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    this.gridAPI.setGridOption('rowData', []);
    this.retrieveData();
  }

  onRowClicked(event: any): void {
    const mouseEvent: MouseEvent = event.event;
    const row = event.data;

    if (!row || row.__isDetail) return;

    // Ignore clicks from action buttons
    const target = mouseEvent.target as HTMLElement;
    if (target.closest(".action-cell")) return;

    // Toggle row expansion
    if (this.expandedParentId === row.id) {
      this.collapseDetailRow();
    } else {
      this.expandDetailRow(row);
    }
  }

  onPaginationChanged(): void {
    if (this.gridAPI) {
      this.updatePaginationInfo();
      
      // If expanded row exists but parent is not on current page, collapse it
      if (this.expandedParentId) {
        setTimeout(() => this.checkAndHandleExpandedRowOnPageChange(), 100);
      }
    }
  }

  private updatePaginationInfo(): void {
    this.lastPage = this.gridAPI.paginationIsLastPageFound();
    this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
    this.nextPage = this.currentPage + 1;
    this.nextPagePlusOne = this.currentPage + 2;
    this.totalPages = this.gridAPI.paginationGetTotalPages();
  }

  // ========== ROW EXPANSION LOGIC ==========
  private expandDetailRow(row: any): void {
    this.collapsePreviousDetailRow();
    this.expandedParentId = row.id;
    this.isDetailExpanded = true;

    this.adjustPageSizeForExpandedRow();
    this.updateGridData();
    this.scrollToRow(row.id);
  }

  private collapseDetailRow(): void {
    this.expandedParentId = null;
    this.isDetailExpanded = false;
    this.restoreOriginalPageSize();
    this.updateGridData();
  }

  private collapsePreviousDetailRow(): void {
    if (this.expandedParentId) {
      this.collapseDetailRow();
    }
  }

  private adjustPageSizeForExpandedRow(): void {
    if (!this.expandedParentId) return;
    
    const currentPage = this.gridAPI.paginationGetCurrentPage();
    const pageSize = this.gridAPI.paginationGetPageSize();
    const allParentRows = this.getAllParentRows();
    const parentRowIndex = allParentRows.findIndex(row => row.id === this.expandedParentId);
    
    if (parentRowIndex === -1) return;

    const parentPage = Math.floor(parentRowIndex / pageSize);
    const isOnCurrentPage = parentPage === currentPage;
    const isLastRowOnCurrentPage = (parentRowIndex % pageSize) === (pageSize - 1);

    if (isOnCurrentPage && isLastRowOnCurrentPage && pageSize === this.originalPageSize) {
      this.gridAPI.setGridOption('paginationPageSize', pageSize + 1);
    } else if (!isOnCurrentPage && pageSize !== this.originalPageSize) {
      this.restoreOriginalPageSize();
    }
  }

  private checkAndHandleExpandedRowOnPageChange(): void {
    if (!this.expandedParentId) return;
    
    const currentPage = this.gridAPI.paginationGetCurrentPage();
    const pageSize = this.gridAPI.paginationGetPageSize();
    const allParentRows = this.getAllParentRows();
    const parentRowIndex = allParentRows.findIndex(row => row.id === this.expandedParentId);
    
    if (parentRowIndex === -1) {
      this.collapseDetailRow();
      return;
    }

    const parentPage = Math.floor(parentRowIndex / pageSize);
    if (parentPage !== currentPage) {
      this.collapseDetailRow();
    }
  }

  private getAllParentRows(): any[] {
    const allParentRows: any[] = [];
    this.gridAPI.forEachNodeAfterFilterAndSort((node) => {
      if (!node.data?.__isDetail) {
        allParentRows.push(node.data);
      }
    });
    return allParentRows;
  }

  // ========== GRID DATA MANAGEMENT ==========
  private updateGridData(): void {
    const rows: any[] = [];
    const allParentRows = this.getAllParentRows();

    allParentRows.forEach(parentRow => {
      rows.push(parentRow);
      
      if (this.expandedParentId && parentRow.id === this.expandedParentId) {
        rows.push(this.createDetailRow(parentRow));
      }
    });

    this.gridAPI.setGridOption('rowData', rows);
    this.gridAPI.resetRowHeights();
  }

  private createDetailRow(parentRow: any): any {
    return {
      id: `detail_${parentRow.id}`,
      __isDetail: true,
      devid: parentRow.id,
      deviationId: parentRow.id,
      ...this.copyParentDataForFiltering(parentRow)
    };
  }

  private copyParentDataForFiltering(parentData: any): any {
    const detailData: any = {};
    const fieldsToCopy = [
      'deviationId', 'state', 'deviationFor', 'productName', 
      'dateClosure', 'status', 'createdBy', 'createdDate', 
      'lastModifiedBy', 'lastModifiedDate', 'vaultSyncStatus', 'vaultReference'
    ];
    
    fieldsToCopy.forEach(field => {
      if (parentData[field] !== undefined) {
        detailData[field] = parentData[field];
      }
    });
    
    return detailData;
  }

  private scrollToRow(rowId: string): void {
    setTimeout(() => {
      const node = this.gridAPI.getRowNode(rowId);
      if (node) {
        this.gridAPI.ensureNodeVisible(node);
      }
    }, 50);
  }

  // ========== DATA RETRIEVAL ==========
  retrieveData(): void {
    this.spinner.start();
    this.deviationService.getALLDeviations().subscribe({
      next: (res: any[]) => this.handleDataSuccess(res),
      error: () => this.handleFailure(),
    });
  }

  private handleDataSuccess(data: any[]): void {
    this.spinner.stop();
    this.baseRowData = data;
    this.gridAPI.setGridOption('rowData', this.baseRowData);
    this.applyUrlFilterIfNeeded();
  }

  private applyUrlFilterIfNeeded(): void {
    if (this.urlDeviationId && !this.isFilterApplied) {
      this.applyDeviationFilter(this.urlDeviationId);
      this.isFilterApplied = true;
    }
  }

  // ========== FILTER MANAGEMENT ==========
  applyDeviationFilter(deviationId: string): void {
    if (!this.gridAPI) return;

    const filterInstance = this.gridAPI.getFilterInstance("deviationId");
    if (!filterInstance) return;

    filterInstance.setModel({
      type: "equals",
      filter: deviationId,
    });

    this.gridAPI.onFilterChanged();
  }

  onClearDeviationFilter(checked: boolean): void {
    if (checked) {
      this.gridAPI.setFilterModel(null);
      this.gridAPI.onFilterChanged();
      this.clearExpansionState();
      this.restoreOriginalPageSize();
      this.showClearFilterCheckbox = false;
      this.urlDeviationId = null;
      this.isFilterApplied = false;
      this.retrieveData();  
    }
  }

  private clearExpansionState(): void {
    this.expandedParentId = null;
    this.isDetailExpanded = false;
  }

  // ========== PAGE SIZE MANAGEMENT ==========
  private restoreOriginalPageSize(): void {
    const currentPageSize = this.gridAPI.paginationGetPageSize();
    if (currentPageSize !== this.originalPageSize) {
      this.gridAPI.setGridOption('paginationPageSize', this.originalPageSize);
    }
  }

  onPageSizeChanged(newPageSize: any): void {
    const newSize = Number(this.pageSize);
    this.gridAPI.setGridOption('paginationPageSize', newSize);
    this.originalPageSize = newSize;
  }

  onSearchChange(searchValue: number): void {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  onBtExport(): void {
    this.gridAPI.exportDataAsCsv();
  }

  onRefresh(): void {
    this.retrieveData();
  }

  onBtNext(): void {
    this.gridAPI.paginationGoToNextPage();
  }

  onBtPrevious(): void {
    this.gridAPI.paginationGoToPreviousPage();
  }

  onBtFirst(): void {
    this.gridAPI.paginationGoToFirstPage();
  }

  onBtLast(): void {
    this.gridAPI.paginationGoToLastPage();
  }

  // ========== CRUD OPERATIONS ==========
  EditIcon({ rowData }): void {
    if (rowData.status === "No") {
      this.showSnackbar(this.constants.deleterowMsg);
      return;
    }
    if (rowData.state === "COMPLETED") {
      this.showSnackbar("This record is completed and cannot be edited.");
      return;
    }


    this.openDeviationDialog(rowData.id);
  }

  deleteIcon({ rowData }): void {
    if (rowData.status === "No") {
      this.showSnackbar(this.constants.deleterowMsg);
      return;
    }
    if (rowData.state === "COMPLETED") {
      this.showSnackbar("This record is completed and cannot be deleted.");
      return;
    }

    if (!confirm("Are you sure you want to delete the selected record?")) {
      return;
    }

    this.spinner.start();
    this.deviationService.softDeleteDeviation(rowData.id).subscribe({
      next: (res: any) => this.handleDeleteResponse(res),
      error: (err) => this.handleFailure(err),
    });
  }

  private handleDeleteResponse(res: any): void {
    if (res.error) {
      this.handleFailure(res);
      return;
    }

    this.spinner.stop();
    this.handleSuccess(res);
    this.retrieveData();
  }

  onAdd(): void {
    this.openDeviationDialog(null);
  }

  private openDeviationDialog(deviationId: string | null): void {
    const dialogConfig = {
      maxWidth: "100vw",
      height: "97%",
      width: "90%",
      data: deviationId 
        ? { deviationId }
        : { 
            deviationFor: this.deviationFor,
            uniqueRecordId: this.generateUniqueId()
          },
      disableClose: true,
    };

    this.dialog.open(DeviationComponent, dialogConfig)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.retrieveData();
        }
      });
  }

  private generateUniqueId(): number {
    return Math.floor(1000 + Math.random() * 9000);
  }

  // ========== UTILITY METHODS ==========
  private showSnackbar(message: string): void {
    this.snackbar.open(message, "OK", { duration: 5000 });
  }

  private handleFailure(res?: any): void {
    this.spinner.stop();
    const message = res?.statusMessage || "Operation failed. Please try again.";
    this.snackbar.open(message, "Ok", { duration: 4000 });
  }

  private handleSuccess(res: any): void {
    if (res && res.error === false) {
      this.snackbar.open(res.statusMessage, "Ok", { duration: 3000 });
    }
  }
} 